/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ListItemValidationMessage,
    ListItemValidationMessageFromJSON,
    ListItemValidationMessageFromJSONTyped,
    ListItemValidationMessageToJSON,
} from './';

/**
 * 
 * @export
 * @interface DateTimeRestrictionValidationData
 */
export interface DateTimeRestrictionValidationData {
    /**
     * 
     * @type {Array<ListItemValidationMessage>}
     * @memberof DateTimeRestrictionValidationData
     */
    readonly dateRanges?: Array<ListItemValidationMessage> | null;
    /**
     * 
     * @type {Array<ListItemValidationMessage>}
     * @memberof DateTimeRestrictionValidationData
     */
    readonly timeRanges?: Array<ListItemValidationMessage> | null;
    /**
     * 
     * @type {number}
     * @memberof DateTimeRestrictionValidationData
     */
    readonly index?: number;
}

export function DateTimeRestrictionValidationDataFromJSON(json: any): DateTimeRestrictionValidationData {
    return DateTimeRestrictionValidationDataFromJSONTyped(json, false);
}

export function DateTimeRestrictionValidationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): DateTimeRestrictionValidationData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'dateRanges': !exists(json, 'dateRanges') ? undefined : (json['dateRanges'] === null ? null : (json['dateRanges'] as Array<any>).map(ListItemValidationMessageFromJSON)),
        'timeRanges': !exists(json, 'timeRanges') ? undefined : (json['timeRanges'] === null ? null : (json['timeRanges'] as Array<any>).map(ListItemValidationMessageFromJSON)),
        'index': !exists(json, 'index') ? undefined : json['index'],
    };
}

export function DateTimeRestrictionValidationDataToJSON(value?: DateTimeRestrictionValidationData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
    };
}


